import type { FaireProductEntity } from "../../entity_types/product";

export const p_r7c7mtemej: FaireProductEntity = {
  token: "p_r7c7mtemej",
  type: "product",
  name: "Vintage Dictionary Wood Shelf Sign \u2013 Gratitude Quote",
  brandName: "Bramble Mountain",
  imageUrl:
    "https://cdn.faire.com/fastly/47bf98bf3b1971cc7334afa5b486cd7997a8efe72b485a71b28b39ba276ab06b.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6937e9b3daaaf14b7594e926e96bc63b0a12905f77109e75534d131e9afa1758.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
